var _clipPath, _mask, _mask2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSl2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 42,
    viewBox: "0 0 130 42",
    width: 130,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 .571533h130v40.8571h-130z"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "b",
    height: 42,
    maskUnits: "userSpaceOnUse",
    width: 130,
    x: 0,
    y: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "m130 .571533h-130v40.857167h130z",
    fill: "#fff"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "c",
    height: 41,
    maskUnits: "userSpaceOnUse",
    width: 131,
    x: -1,
    y: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "m129.871 1.18628h-129.999906v40.56732h129.999906z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m30.8814 34.7159-3.6562-6.2165-3.5803 6.2165h-4.2849l5.5054-9.3643-5.6115-8.6935h4.477l3.5955 5.8042 3.4286-5.8042h4.2849l-5.5205 8.9763 5.6721 9.0815z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.1152 28.5757c0 3.9672-2.9246 6.4493-6.756 6.4493-3.3714 0-6.2217-1.9078-6.4998-6.063h3.656c.2513 1.8059 1.6638 2.5873 3.2028 2.5873 1.9165 0 2.7425-1.316 2.7425-3.0186 0-1.78-1.2845-2.8891-3.0746-2.8891-1.4884 0-2.4711.7228-2.9245 1.4972h-3.4961l1.207-10.4752h11.4926l-.3826 3.5084h-8.2225l-.3254 3.467s.8631-1.035 3.4792-1.035c3.1538 0 5.8996 2.1666 5.8996 5.9854"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70.1587 25.3106s.9153 10.0423-9.003 10.0423c-5.2254 0-9.2709-4.0966-9.2709-9.6593 0-5.5628 4.0556-9.6594 9.4226-9.6594 4.135 0 7.4336 2.4355 8.6895 6.1855h-2.3228c-1.1007-2.4632-3.4808-4.0708-6.3869-4.0708-4.1348 0-7.1976 3.2152-7.1976 7.6068 0 4.2587 2.906 7.5515 7.1976 7.5515 3.6123 0 6.3599-2.3562 6.6751-6.0784h-7.051v-1.8975h9.2474z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m81.3035 20.0887v2.2769c-.3045-.0356-.6107-.0534-.9171-.0535-3.0105 0-5.104 2.0079-5.104 5.7853v6.9617h-2.1711v-14.7272h2.1711v3.2946c.8631-2.1958 2.5908-3.5878 5.1294-3.5878.2979-.0001.5957.0177.8917.0536"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m97.2015 27.6971c0 4.4191-3.2714 7.6584-7.4334 7.6584-4.1366 0-7.4068-3.2668-7.4068-7.6584 0-4.4191 3.3241-7.6602 7.4068-7.6602 4.1091 0 7.4334 3.2411 7.4334 7.6602zm-12.6421 0c0 3.2393 2.3026 5.5438 5.2087 5.5438 2.9059 0 5.2252-2.3045 5.2252-5.5438s-2.3293-5.5437-5.2252-5.5437c-2.8791 0-5.2087 2.2767-5.2087 5.5437z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m112.22 20.3325v14.7306h-2.18v-2.9203c-.966 1.9284-2.642 3.2135-5.129 3.2135-3.192 0-5.1044-2.0888-5.1044-5.6784v-9.3454h2.1724v8.9176c0 2.6254 1.204 3.9915 3.56 3.9915 2.853 0 4.501-2.0888 4.501-5.3575v-7.5516h2.173z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m129.873 27.6981c0 4.4467-2.827 7.6584-6.752 7.6584-1.124.0229-2.233-.2693-3.207-.8452-.973-.5759-1.774-1.4134-2.315-2.4216v9.6679h-2.173v-21.4231h2.173v3.0255c.539-1.0197 1.342-1.8685 2.321-2.4539.978-.5854 2.094-.8852 3.228-.8666 3.898 0 6.725 3.1876 6.725 7.6603zm-2.191.0017c0-3.2152-2.041-5.5438-4.947-5.5438s-5.154 2.3028-5.154 5.5438 2.224 5.5437 5.154 5.5437 4.947-2.3044 4.947-5.5437z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m36.2923 13.4817c-1.9469-7.76168-8.1245-13.224132-20.9447-13.224132h-15.478459l2.101889 14.538432c1.57937 13.1188 6.48265 17.3394 15.15977 18.8934.0403.011.0825.0118.1232.0023.0405-.0097.0782-.0292.1096-.0571.0314-.028.0557-.0633.0707-.1031.0149-.0397.0202-.0826.0152-.125.0004-.056-.0154-.111-.0454-.1579-.03-.047-.0729-.0839-.1232-.106-5.8657-2.5268-6.5348-10.8145-7.78719-19.1297l-.96926-6.62672h8.83565c8.1463 0 14.4368-.13109 18.418 6.30422.0277.046.0661.0844.1116.1119.0456.0274.097.0428.1497.045.0361-.0002.0716-.0078.1047-.0223.033-.0146.0629-.0356.0879-.0622.0251-.0265.0446-.0579.0575-.0922.0129-.0344.019-.071.018-.1079.0006-.0275-.0034-.0549-.0119-.081",
    fill: "#62c03e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSl2);
export default __webpack_public_path__ + "static/media/sl2.cfa2075d4dace825bc5498267a1ee0bd.svg";
export { ForwardRef as ReactComponent };